/**
 * Workspace Management Hooks
 *
 * These hooks provide functionality for managing workspace data,
 * workspace operations, and workspace-related state.
 */
import { useAuthContext } from './core-hooks';
/**
 * Hook to get current workspace
 */
export function useCurrentWorkspace() {
    const { workspace } = useAuthContext();
    return workspace;
}
/**
 * Hook to get current workspace ID
 */
export function useCurrentWorkspaceId() {
    const { workspace } = useAuthContext();
    return workspace?.id || null;
}
/**
 * Hook to get current workspace name
 */
export function useCurrentWorkspaceName() {
    const { workspace } = useAuthContext();
    return workspace?.name || null;
}
/**
 * Hook to get current workspace slug
 */
export function useCurrentWorkspaceSlug() {
    const { workspace } = useAuthContext();
    return workspace?.slug || null;
}
/**
 * Hook to get current workspace domain
 */
export function useCurrentWorkspaceDomain() {
    const { workspace } = useAuthContext();
    return workspace?.domain || null;
}
/**
 * Custom hook for workspace management (wrapper around auth context)
 * Provides a convenient interface for workspace-related operations
 */
export function useWorkspace() {
    const { workspace, isLoading, isAuthenticated } = useAuthContext();
    return {
        workspace,
        workspaceId: workspace?.id || null,
        workspaceName: workspace?.name || null,
        workspaceSlug: workspace?.slug || null,
        workspaceDomain: workspace?.domain || null,
        isLoading,
        isAuthenticated,
    };
}
